import { insightArticle } from '@/mocks/homeData';

export default function InsightSection() {
  return (
    <section id="insight" aria-labelledby="insight-title" className="scroll-mt-28 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <aside className="lg:col-span-4">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-56 w-full md:h-72">
                <img
                  src={insightArticle.image}
                  alt={insightArticle.title}
                  className="h-full w-full object-top"
                />
              </div>
            </div>

            <nav
              aria-label="本文目录"
              className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                <i className="ri-list-check-2 text-primary-600" aria-hidden="true" />
                本文目录
              </h3>
              <ol className="mt-4 space-y-3 text-sm">
                {insightArticle.outline.map((item, index) => (
                  <li key={item} className="flex items-start gap-3 text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] text-secondary-800">
                      {index + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ol>
            </nav>
          </aside>

          <div className="lg:col-span-8">
            <p className="text-xs tracking-[0.25em] text-primary-600">{insightArticle.tag}</p>
            <h2
              id="insight-title"
              className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl"
            >
              {insightArticle.title}
            </h2>
            <p className="mt-5 border-l-2 border-primary-400 pl-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {insightArticle.lead}
            </p>

            <article className="mt-8 space-y-8">
              {insightArticle.paragraphs.map((para) => (
                <section key={para.heading}>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                    {para.heading}
                  </h3>
                  <p className="mt-3 text-sm leading-loose text-foreground-700 md:text-base">
                    {para.body}
                  </p>
                </section>
              ))}
            </article>

            <div className="mt-8 flex flex-wrap items-center gap-3 rounded-lg border border-accent-300/60 bg-accent-50 p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-xl text-background-50">
                <i className="ri-lightbulb-flash-line" aria-hidden="true" />
              </span>
              <p className="text-sm leading-relaxed text-accent-900">
                记住这五个问题,下次再看到一条刷屏爆料,你至少能先稳住手,而不是急着转发。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}